export default __webpack_public_path__ + "static/media/lender-agreement.ed90ec8d.png";